<dl class="cl-dl it-dl-radio">
  <dt>
    <div class="form-check cl-spacing-none">
      <input
        [id]="radioId"
        [name]="name"
        [disabled]="disabled"
        [checked]="checked"
        [class.invalid]="invalid"
        (change)="onSelect()"
        [attr.aria-invalid]="invalid || null"
        class="form-check-input it-dl-radio-input"
        type="radio"
      >
      <label class="form-check-label" [class.invalid]="invalid" [for]="radioId">
        {{ label }}
        @if (required) {
          <span class="required">*</span>
        }
      </label>
    </div>
  </dt>
  <dd class="it-dl-radio-details">
    <p>{{ description }}</p>
    <ng-content></ng-content>
  </dd>
</dl>
